import { Badge } from '@mantine/core'
import React from 'react'

interface ReportElementProps {
  name: string
}

export default function ReportElement({ name }: ReportElementProps) {
  return (
    <Badge
      size="lg"
      radius="md"
      variant="light"
      className="px-4 py-2 transition-all duration-200 hover:scale-105"
      styles={{
        root: {
          backgroundColor: '#3A55DD10',
          color: '#3A55DD',
          fontSize: '0.9rem',
          cursor: 'default',
        },
      }}
    >
      {name}
    </Badge>
  )
}
